import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { OnInit } from '@angular/core';
import { ApiService } from './api.service'
import { UtilService } from './util.service';

@Injectable({ providedIn: 'root' })

export class MessageServices {

    private subject = new Subject<any>();

    public message: String;
    public type: String;
    public time: number = 5000

    private messageMap = {};
    constructor(private apiService: ApiService,private util: UtilService) {
        this.util.startLoader()
        this.apiService.getMessagesAndCode().subscribe(messages => {
            this.util.stopLoader()
            messages.forEach(element => {
                this.messageMap[element.messageCode] = element.messageDescription;
            });
        })
    }

    getMessage(): Observable<any> {
        return this.subject.asObservable();
    }

    sendMessage(message: string, type: string) {
        this.subject.next({ text: message, type: type });
    }

    clear() {
        this.message = ''
        this.type = ''
        this.subject.next();
    }

    getType() {
        return this.type;
    }

    getMessageText() {
        return this.message;
    }


    error(code) {
        this.message = this.messageMap[code]
        this.type = 'ERROR';
        this.timeout(this.time);
    }

    errorText(code) {
        this.message = code
        this.type = 'ERROR';
        this.timeout(this.time);
    }

    infoText(code) {
        this.message = code
        this.type = 'INFO';
        this.timeout(this.time);
    }

    success(code) {
        this.message = this.messageMap[code]
        this.type = 'SUCCESS';
        this.timeout(this.time);
    }

    successText(code) {
        this.message = code
        this.type = 'SUCCESS';
        this.timeout(this.time);
    }

    info(code) {
        this.message = this.messageMap[code]
        this.type = 'INFO';
        this.timeout(this.time);
    }



    timeout(timeout) {
        setTimeout(() => {
            this.clear()
        }, timeout)
    }



}